export const sanitizePageTitle = (pageTitle: string) => {
  return pageTitle.replace(/( - )?Ribit$/g, "");
};
